module.exports = __webpack_public_path__ + "img/product_bg.1c1a735a.png";